import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Persons = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="189" viewBox="0 0 343 189" width="343" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M82.42 152.77c40.64 0 73.58-3.04 73.58-6.79s-32.94-6.79-73.58-6.79-73.58 3.04-73.58 6.79 32.94 6.79 73.58 6.79Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m115.68 42.33-.37.87c-5.32-1.93-15.6-2.4-29.55-1.8q-.4-1.16-.68-2.38l6.12-.57a2.2 2.2 0 0 0 1.88-1.47l3.98-11.65c.2-.55 1.02-.48 1.1.11l.16 11.28a3 3 0 0 0 2.9 2.57c3.94.06 11.41-.33 14.46 3.03z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M130 51.68a5.4 5.4 0 0 1-5.65 5.5l-30.54-.36a5.5 5.5 0 0 1-5.45-6.24l.48-3.47c2.99 3.83 7.28 6.24 12.05 6.24 2.62 0 5.11-.73 7.31-2.03a18.2 18.2 0 0 0 7.48-8.98c-3.05-3.36-10.52-2.97-14.46-3.03a3 3 0 0 1-2.9-2.57l-.16-11.28c-.08-.59-.9-.66-1.1-.11L93.08 37a2.2 2.2 0 0 1-1.88 1.47l-6.12.57-.41.03a2.28 2.28 0 0 1-2.5-2.44c1.08-10.8 8.16-26.69 23.32-26.59 20.92.14 24.17 27.56 24.5 41.66z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M88.45 51.45c2.51 0 4.55-2.75 4.55-6.15s-2.04-6.15-4.55-6.15-4.55 2.75-4.55 6.15 2.04 6.15 4.55 6.15Z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M115.31 43.2a18 18 0 0 1-7.11 8.11 14 14 0 0 1-7.31 2.03c-4.77 0-9.06-2.4-12.05-6.24a20 20 0 0 1-3.09-5.71c13.96-.6 24.23-.13 29.55 1.8z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path d="M113.88 51.47c2.59 0 4.69-2.38 4.69-5.32s-2.1-5.32-4.69-5.32-4.69 2.38-4.69 5.32 2.1 5.32 4.69 5.32Z" stroke="white" />
      <path className={strokeStyle} d="M116.61 43.78a5 5 0 0 0-.93-1.45" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M48.2 132.91c11.19 5.84 24.83 7.67 38.33 9.57 2.61-17.01 6.26-56.38-4.47-64.7-2.6-.81-5.19 1-5.19 1-15.03-1.07-38.43 50.86-28.68 54.13z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M119.56 73.13c-4.26 2.63-15.98 9.17-27.69 9.17-10.35 0-6.91-6.32-3.98-10.05l.07-.04c5.35-2.85 11.23-4.37 17.57-3.7q4.41.48 8.33 1.95 3 1.1 5.7 2.67Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M126.97 78.5c-16.27 6.36-24.12 47.8-25.95 63-4.8 1.79-23.78 2.42-37.84 1.18a8.68 8.68 0 0 1-7.54-11.21c3.96-12.89 11.9-42.33 22.02-51.76q.41-1.36 1.21-2.62c1.57-2.54 7.47-6.71 12.24-8.14-.02.72-1.15 1.97-3.16 3.26l-.07.04c-2.92 3.73-6.36 10.05 3.98 10.05 11.71 0 23.44-6.53 27.69-9.17a44 44 0 0 1 7.41 5.37z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M127.74 81.04c-12.71 4.77-20.89 43.45-23.43 60.47q-1.2.09-3.29-.02c1.83-15.2 9.68-56.65 25.95-63z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M143.76 143.73c-12.42 2.26-25.99-.02-39.45-2.21 2.55-17.02 10.72-55.7 23.43-60.47 2.73 0 4.66 2.49 4.66 2.49 14.67 3.43 21.64 59.96 11.36 60.19Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M114.26 68.93c0 .58.11 1.12.11 1.65.01.83-.25 1.63-1.67 2.46-4.92 2.87-21.3 2.46-23.99.71l-.13-.09a2.4 2.4 0 0 1-1.05-2.04c-.05-1.57 0-2.56-.85-4.37-2.38-5.13 7.36-7.26 15.36-5.94 5.79.95 10.31-1.1 12.06 1.22 1.83 2.4.16 4.06.15 6.4z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M93.2 64.54c2.24 2.47 10.05 1.72 15.66-.58" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M98.98 66c3.2 0 5.78-.57 5.78-1.27s-2.59-1.27-5.78-1.27-5.78.57-5.78 1.27S95.79 66 98.98 66Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M49.7 74.84v5.47" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M52.51 77.57h-5.62" strokeWidth={strokeWidth} />
      <path d="M110.97 20.47v5.67" stroke="white" />
      <path d="M113.88 23.31h-5.82" stroke="white" />
      <path
        d="M124.57 119.95c-6-5.55-19.91-12.24-33.72-9.46a18.4 18.4 0 0 0-14.36 13.5c-1.18 4.31-.9 12.5 5.81 18.03 3.68 3.03 10.07 3.57 11.81 3.65 11.22.51 35.34-.34 39.29-1"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M124.57 119.95c-6-5.55-19.91-12.24-33.72-9.46a18.4 18.4 0 0 0-14.36 13.5c-1.18 4.31-.9 12.5 5.81 18.03 3.68 3.03 10.07 3.57 11.81 3.65 11.22.51 35.34-.34 39.29-1"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M85.51 118.73c-3.52 1.59-7.82 7.03-4.67 15.91s14.46 9.74 18.08 8.77 6.55-7.05 2.9-15.88c-3.66-8.83-12.27-10.64-16.31-8.81z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M66.84 125.37q.15.38.35.76a10 10 0 0 0 1.53 2.18c.97-.4 1.7-1.72.85-2.78-.81-1.02-2.12-.92-2.73-.15z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M70.97 126.01c-.78 1.21-2.45 1.91-4.18.79q-.4-.26-.71-.62a6 6 0 0 1-.69-.99q.39.03.98-.1l.08-.02c1.59-.44 2.29-2.99.68-4.39-1.25-1.09-2.55-.35-3.03.65a25 25 0 0 1-.4-3.05c-.05-.83.04-2.44.44-4.04.48-1.93 1.4-3.85 3.02-4.46a3 3 0 0 1 1.56-.17c1.24.2 2.22 1.17 2.81 1.93a16 16 0 0 0-.79 2.66 26 26 0 0 0-.46 6.22c.06 1.86.27 3.66.58 5.1l.12.5z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M77.14 129.7v.02c-1.21.42-4.22.73-5.58-2a8 8 0 0 1-.59-1.71l-.12-.5.37.03c.73.01 1.6-.17 2.12-1 1.01-1.6.33-3.97-1.61-4.45-.72-.18-1.17.02-1.45.33a26 26 0 0 1 .46-6.22q.33-1.5.79-2.66c.73-1.82 1.7-2.96 2.76-3.27 2.91-.84 5.36 1.05 7.36 4.47-1.54 1.49-2.68 4.09-3.37 6.99a52 52 0 0 0-.74 3.57 26 26 0 0 0-.4 6.4Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M95.48 135.57a14 14 0 0 1-2.04 5.04q-1.13 1.3-2.42 2.1a7.8 7.8 0 0 1-9.13-.44l-.03-.02a6 6 0 0 1-1.24-1.26 10 10 0 0 1-1.64-4.63c-.11-.91-.13-1.78-.11-2.51-1.03-.82-1.55-2.29-1.73-4.13h.02c.52.28 1.19.39 1.97.07 2.1-.87 2.74-3.9 1.57-5.57-.82-1.17-2.08-1.42-3.16-.91q.3-1.79.74-3.57c.69-2.89 1.84-5.5 3.37-6.99 1.89-1.83 4.36-1.97 7.35 1.12 3.48 3.61 5.69 9.27 6.48 14.32.44 2.79.45 5.4 0 7.38Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M89.17 124.62c-.12.38-.32.97-.59 1.67-1.34 3.44-4.47 9.66-8.82 8.07a3 3 0 0 1-.89-.5"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M70.27 120.42c.06 1.86.27 3.66.58 5.1l.37.02c.73.01 1.6-.17 2.12-1 1.01-1.6.33-3.97-1.61-4.45-.72-.18-1.17.02-1.45.33z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M64.09 121.33c.25 1.28.65 2.68 1.25 3.79l.04.08q.39.03.98-.1c1.64-.37 2.39-2.98.76-4.41-1.24-1.09-2.55-.35-3.03.65z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M77.54 123.31a26 26 0 0 0-.38 6.41c.52.28 1.19.39 1.97.07 2.1-.87 2.74-3.9 1.57-5.57-.82-1.17-2.08-1.42-3.17-.91z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M81.86 142.26a10 10 0 0 1-5.26.99c-6.26-.48-9.44-3.81-10.67-7.67-1.17-3.69-.46-7.39.13-9.4q.33.38.71.62c1.74 1.12 3.4.42 4.18-.79q.26 1.04.59 1.71c1.36 2.73 4.37 2.43 5.58 2 .18 1.84.7 3.31 1.73 4.13q-.04 1.13.11 2.51a10 10 0 0 0 1.64 4.63q.52.71 1.24 1.26z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        d="m.21 99.93 13.12 41.36h56.35l-12.65-39.86c-1-3.16-3.53-5.61-6.69-6.73a12 12 0 0 0-3.91-.67H4.92c-3.29 0-5.65 2.95-4.72 5.9z"
        fill={shades.white}
      />
      <path d="m23.72 115.92 1.71 6.39h3.42l-.85-3.2h3.42l.85 3.2h3.42l-1.71-6.39z" fill={shades.black} />
      <path d="M13.33 141.29v.23c0 2.36 2.05 4.27 4.58 4.27h85.72v-.7c0-2.1-1.82-3.8-4.07-3.8z" fill={shades.white} />
      <path
        className={strokeStyle}
        d="M260.92 152.41c41.27 0 74.73-2.37 74.73-5.29s-33.46-5.29-74.73-5.29-74.73 2.37-74.73 5.29 33.46 5.29 74.73 5.29Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="m272.09 106.3-.15.03z" fill={shades.secondary.light} />
      <path
        d="M287.74 108.6a100 100 0 0 1-13.9 2.83c-.64-2.55-1.37-5.49-2.19-8.59q5.94-.82 11.26-2.17c1.05 2.66 2.86 5.32 4.82 7.93z"
        fill={shades.primary.dark}
      />
      <path
        d="M282.92 100.67q-5.32 1.35-11.26 2.17-.63-2.4-1.31-4.88a99 99 0 0 0 10.94-2.18l1.25 3.82q.17.53.39 1.07z"
        fill={shades.white}
      />
      <path
        d="M296.74 124.68c-1.78 23.17-14.81 20.08-24.37 20.08 0 0-66.95 1.36-73.58 1.36s-12.49-5.63-12.57-13.86c-.05-5.29 2.69-12.78 5.2-20.74q12.22 4.59 28.33 5.71a43 43 0 0 0 1.92-8.59c.22-1.65.38-3.32.49-4.9q-15.46-1.32-27.19-5.96c1.11-5.75 1.96-11.38 3.82-15.71 1.92-4.47 5.01-7.5 6.58-9.39a.9.9 0 0 0 .14-.96c-2.98-6.96-5.45-16.67-4.87-23.73.75-9.28 8.68-12.49 17.02-12.6 10.01-.14 25.07 6.47 36.95 15.3 5.96 4.44 5.28 9.95 4.24 11.71l-.26.41c-.4.59 4.19 1.87 9.53 7.05 5.63 5.45 10.21 17.15 13.16 25.92q-5.18 1.35-10.94 2.18.7 2.49 1.31 4.88c.81 3.1 1.54 6.04 2.19 8.59a100 100 0 0 0 13.9-2.83c4.3 5.73 9.37 11.24 9 16.07z"
        fill={shades.white}
      />
      <path d="M222.17 103.75a80 80 0 0 1-.49 4.9q-15.8-1.17-27.81-5.7.61-2.57 1.1-5.15 11.74 4.63 27.19 5.96z" fill={shades.white} />
      <path
        d="M221.67 108.65a44 44 0 0 1-1.92 8.59q-16.12-1.12-28.33-5.71c.83-2.63 1.63-5.31 2.3-7.99l.15-.6q12.01 4.53 27.81 5.7z"
        fill={shades.primary.dark}
      />
      <path d="m272.09 106.3-.15.03z" fill={shades.secondary.medium} />
      <path className={strokeStyle} d="m216.02 42.42-.11.15q.12-.17.28-.33z" fill={shades.primary.medium} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M258.59 62.81c-3.38 3.17-9.57 4.04-9.57 4.04" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M198.79 146.12c6.63 0 73.58-1.36 73.58-1.36 9.55 0 22.59 3.09 24.37-20.08.56-7.33-11.39-16.23-14.21-25.08s-7.92-23.45-14.41-29.74c-5.35-5.18-9.93-6.46-9.53-7.05l.26-.41c1.04-1.76 1.72-7.27-4.24-11.71-11.88-8.82-26.94-15.43-36.95-15.3-8.33.11-16.27 3.32-17.02 12.6-.58 7.07 1.89 16.77 4.87 23.73.14.32.09.69-.14.96-1.57 1.88-4.66 4.92-6.58 9.39-2.48 5.77-3.16 13.86-5.07 21.46-2.7 10.75-7.57 21.69-7.5 28.73.08 8.23 5.95 13.85 12.57 13.85z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M227.54 58.33c4.73 2.78 9.81 4.65 14.46 4.07 5.83-.72 8.65-2.28 9.61-4.08-3.62-1.54-10.68-3.99-16.88-2.85-3.48.64-5.74 1.75-7.19 2.86Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m216.67 50.19.05.05c1.86 1.67 4 3.44 6.31 5.12.51-2.55 2.25-5.1 7.01-5.88 7.43-1.22 16.75 2.88 21.46 5.33a10 10 0 0 0-3.78-3.85c-4.84-2.96-19.13-8.55-25.53-10.13a7 7 0 0 0-4.38.23q-.26.11-.51.27l-.28.17q-.16.1-.31.24a3 3 0 0 0-.53.51l-.16.17-.11.15-.05.06q-.1.12-.19.27a5.8 5.8 0 0 0 1.01 7.28z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M223.54 55.73q1.69 1.21 3.47 2.29c.31.19.71.17 1.01-.04 1.46-.99 3.6-1.94 6.71-2.51 6.2-1.14 13.26 1.31 16.88 2.85.6-1.13.48-2.35-.11-3.52-4.71-2.45-14.03-6.55-21.46-5.33-4.37.72-6.19 2.92-6.86 5.25-.11.37.04.77.36 1z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M231.85 68.06c-2.26-1.19-10.5-5.03-17.3-1.88a34 34 0 0 0-8.81 6.09" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M217.33 121.68c5.37-6.05 5.29-25.4 4.92-28.11" strokeWidth={strokeWidth} />
      <path
        d="M238.63 67.74c.54 0 1 .45 1.05 1.04.26 2.98.46 22.25.51 24.02.06 2.16-2.22 1.84-2.41-2.05-.1-1.92.22-15.72.05-18.26l-.24-3.52c-.05-.67.44-1.24 1.05-1.24z"
        fill={shades.primary.medium}
      />
      <path
        d="M252.61 64.25c-.53.12-.9.65-.84 1.24.28 2.98.63 29.26.9 31.01.33 2.13 2.5 1.33 2-2.53-.25-1.9-.13-22.71-.41-25.24l-.39-3.5c-.07-.67-.65-1.12-1.25-.99z"
        fill={shades.primary.medium}
      />
      <path className={strokeStyle} d="M261.83 75.53c5.36 8.16 9.86 27.5 12.51 37.89" strokeWidth={strokeWidth} />
      <path
        d="M211.8 121.68c5.65-5.37 20.04-9.22 33.04-6.52 6.55 1.36 11.65 6.06 13.52 13.06 1.11 4.17.85 12.1-5.47 17.44-3.46 2.93-9.49 3.45-11.12 3.53-10.57.49-39.26-2.42-42.98-3.06"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M211.8 121.68c5.65-5.37 20.04-9.22 33.04-6.52 6.55 1.36 11.65 6.06 13.52 13.06 1.11 4.17.85 12.1-5.47 17.44-3.46 2.93-9.49 3.45-11.12 3.53-10.57.49-39.26-2.42-42.98-3.06"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M249.88 123.13c3.31 1.54 7.37 6.8 4.4 15.4-2.97 8.59-5.26 10.88-15.4 10.72-3.53-.06-7.8-9.04-4.36-17.59 3.44-8.54 11.55-10.3 15.35-8.53z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M292.18 107.99c6.99 3.43 13.18 13.62 14.18 22.91s-5.21 12.32-11.03 13.31c-5.83.99-32.59 5.54-29.33-18.02s20.11-21.18 26.18-18.2Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M290.69 119.74c-2.44-1.31-6.52-1.62-10.75 1.39s-8.95 12.41-3.8 19.19c5.15 6.77 19.07 3.49 20.81-5.4s-2.53-13.17-6.25-15.17z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M249.87 54.75c10.6 0 19.21-8.24 19.21-18.4s-8.6-18.4-19.21-18.4c-10.6 0-19.21 8.24-19.21 18.4s8.6 18.4 19.21 18.4Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        d="M227.67 36.35c1 4.52 2.63 7.54 6.65 10.8 3.34 2.71 4.27-4.28 4.48-7.54a12.6 12.6 0 0 1-5.36-3.18c1.85.67 3.67 1.09 5.44 1.16 2.77.12 5.65-.81 8.17-2.78l-.05-.13-.06-.17-.06-.17.37.23c11.01 6.73 20.19 4.65 28.44-1.95 3.82-7.44.35-12.45-2.29-14.92a1.59 1.59 0 0 0-2.64.93c-.33 2.08-.86 3.53-1.6 4.58a6 6 0 0 1-3.71 2.37l3.71-2.37c-2.61-8.73-9.5-11.74-14.95-11.54-4.71.17-7.54 1.71-8.87 3.73-1.56-.54-4.7-1.32-7.88-.27a9 9 0 0 0-2.61 1.32c-1.26.9-2.43 2.11-3.46 3.51q-.78 1.09-1.45 2.31-.56 1.05-1.03 2.2c-1.51 3.72-2.1 8-1.24 11.88Z"
        fill={shades.secondary.medium}
      />
      <path
        className={strokeStyle}
        d="M269.16 23.21c.74-1.05 1.27-2.5 1.6-4.58a1.59 1.59 0 0 1 2.64-.93c2.64 2.47 6.11 7.48 2.29 14.92-8.25 6.6-17.43 8.68-28.44 1.95l-.37-.23.06.17.06.17.05.13a12.4 12.4 0 0 1-8.17 2.78 18 18 0 0 1-5.44-1.16c.16.17 2.31 2.37 5.36 3.18-.21 3.26-1.14 10.25-4.48 7.54-4.02-3.26-5.65-6.28-6.65-10.8-.86-3.88-.27-8.16 1.24-11.88q.47-1.14 1.03-2.2.67-1.22 1.45-2.31c1.03-1.4 2.2-2.61 3.46-3.51a9 9 0 0 1 2.61-1.32c3.18-1.05 6.32-.27 7.88.27 1.33-2.02 4.16-3.56 8.87-3.73 5.45-.2 12.34 2.81 14.95 11.54Zm0 0a6 6 0 0 1-3.71 2.37z"
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M265.45 25.58a6 6 0 0 0 3.71-2.37z" fill={shades.secondary.light} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M265.45 25.58a6 6 0 0 0 3.71-2.37z" fill={shades.primary.medium} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m246.89 34.34.06.17.06.17.05.13.01.03.06.16q.34.85.67 1.35c3.33 4.9 20.29 9.19 27.28-2.61q.34-.57.62-1.12c-8.25 6.6-17.43 8.68-28.44 1.95z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M233.45 36.43c.16.17 2.31 2.37 5.36 3.18 1.05.29 2.21.41 3.43.22 2.99-.46 4.32-2.96 4.89-4.83l-.06-.16-.01-.03a12.3 12.3 0 0 1-8.17 2.78 19 19 0 0 1-5.44-1.16Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m247.06 34.81.07-.05" strokeWidth={strokeWidth} />
      <path d="m260.56 48.01 4.91-.14-3.47-8.28h-.22c-.2 0-.38.15-.42.36l-1.48 7.22c-.11.44.24.85.68.84Z" fill={shades.white} />
      <path d="m262 39.59 3.47 8.28 3.1-.09c.32 0 .6-.18.76-.45l.96-1.57-2.77-6.28-3.45.07z" fill={shades.white} />
      <path d="m267.52 39.48 2.77 6.28 3.44-5.66a.48.48 0 0 0-.42-.73l-5.8.11z" fill={shades.white} />
      <path d="m255.53 48.16-2.28.06v.02z" fill={shades.white} />
      <path d="m252.07 39.78 3.52 8.37.68-.02c.16 0 .3-.12.33-.28l1.58-7.76c.05-.22-.12-.42-.35-.42l-5.77.11z" fill={shades.white} />
      <path d="m246.67 39.88 4.13 8.41h.01l2.44-.07 2.28-.06h.06l-3.52-8.38z" fill={shades.white} />
      <path d="m244.95 48.46 5.85-.17-4.12-8.4-1.47.03a.53.53 0 0 0-.52.51l-.28 7.48c-.01.31.24.56.55.55z" fill={shades.white} />
      <path
        className={strokeStyle}
        d="m260.56 48.01 4.91-.14 3.1-.09c.32 0 .6-.18.76-.45l.96-1.57 3.44-5.67a.48.48 0 0 0-.42-.73l-5.8.11-3.45.06-2.07.04h-.22a.43.43 0 0 0-.42.36l-1.48 7.22c-.11.44.24.85.68.84z"
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M253.25 48.22v.02l2.28-.08z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M244.4 47.91c-.01.31.24.56.54.55l5.85-.17 2.44-.06 2.28-.06h.06l.68-.03c.16 0 .3-.12.33-.28l1.58-7.76c.05-.22-.12-.42-.35-.42l-5.77.12-5.39.1-1.47.03a.53.53 0 0 0-.52.51l-.28 7.48z"
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M260.89 41.77h-3.05" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m244.56 41.77-5.75-2.16" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M227.86 35.09c9.31 2.35 31.1-3.46 41.1-11.63.61-.5.86-1.3.6-2.04a16 16 0 0 0-3.42-5.71 1.8 1.8 0 0 0-2.22-.36c-1.4.75-3.25 1.71-5.41 2.73a103 103 0 0 1-9.33 3.91 70 70 0 0 1-6.21 1.96c-2.67.71-5 1.16-7.03 1.44-3.25.45-5.94.38-7.35.28-.6-.04-1.13.38-1.22.98-.31 2.03-.95 6.26-.94 6.65.01.85.6 1.57 1.43 1.78z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M244.75 10.91c6.04.88 10.18 3.88 13.41 7.9 2.76-1.31 4.99-2.5 6.39-3.27a17 17 0 0 0-2.45-1.85c-3.82-2.38-10.4-4.27-17.34-2.78z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M228.35 26.01c1.59.24 4.21.37 8.01-.15.22-6.38 3.32-11.21 8.39-14.96a22 22 0 0 0-2.74.76c-8.55 2.94-12.19 9.47-13.66 14.35Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M244.75 10.91a90 90 0 0 0 4.39 11.67c3.3-1.19 6.39-2.53 9.01-3.77-3.23-4.02-7.37-7.02-13.41-7.9z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M236.37 25.87q2.93-.39 6.78-1.39a71 71 0 0 0 6-1.9 91 91 0 0 1-4.39-11.67c-5.07 3.75-8.17 8.58-8.39 14.96Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M306.45 82.85v6.61" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M303.17 86.16h6.56" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M297.44 74.69v4.2" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M295.36 76.79h4.16" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M278.13 128.99c-.61-.77-1.92-.86-2.73.15-.85 1.06-.12 2.38.85 2.78a7 7 0 0 1-2.34 1.69q-1.38.06-3.02.32a1.7 1.7 0 0 1-1.25-1.03l-.03-.08c.78-1 1.39-2.31 1.85-3.53a14.4 14.4 0 0 0 1.11-7c.99-.76 2.42-1.51 3.65-.83 1.98 1.09 3.18 4.33 1.9 7.53z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M272.35 126.35c-.15.66-.45 1.76-.89 2.94-.32-1.06-1.48-2-2.88-1.13-1.84 1.14-1.52 3.84.03 4.47q.57.22.95.26a4.5 4.5 0 0 1-1.65 1.36c-1.9.82-3.42-.14-4-1.46l.2-.47a30 30 0 0 0 1.4-4.93c.42-2.11.65-4.34.56-6.21a17 17 0 0 0-.35-2.75c.99-.91 2.77-2.08 4.6-1.03 1.5.86 2.09 2.92 2.25 4.89.13 1.65-.03 3.25-.22 4.06Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M265.51 127.38c-.23-.36-.64-.62-1.38-.56-2 .16-3.05 2.38-2.32 4.13.38.9 1.21 1.23 1.93 1.33l.37.04-.2.47a9 9 0 0 1-.86 1.59c-1.79 2.47-4.71 1.68-5.83 1.07v-.02c.47-1.8.66-4.02.65-6.37q-.01-1.8-.14-3.64c-.22-2.96-.92-5.72-2.19-7.44 2.53-3.05 5.24-4.51 7.98-3.21.99.47 1.76 1.76 2.19 3.67q.27 1.22.35 2.75a27 27 0 0 1-.56 6.21z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m257.21 135.43.02.01c-.47 1.79-1.23 3.15-2.38 3.79-.1.73-.27 1.58-.52 2.46a10 10 0 0 1-2.37 4.3q-.64.64-1.46 1.05a7.85 7.85 0 0 1-9.07-1.05 11 11 0 0 1-2.04-2.46 14 14 0 0 1-1.19-5.3 21 21 0 0 1 1.21-7.28c1.61-4.85 4.7-10.07 8.72-13.07 3.44-2.56 5.87-2.02 7.43.09 1.27 1.72 1.97 4.47 2.19 7.44q.14 1.84.14 3.64a2.44 2.44 0 0 0-3.27.38c-1.43 1.46-1.29 4.55.64 5.75a2.2 2.2 0 0 0 1.95.25Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M246.2 128.45c.05.39.15 1.01.31 1.75.76 3.61 2.83 10.25 7.38 9.39q.51-.1.96-.35"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M265.51 127.38a29 29 0 0 1-1.4 4.93q-.18 0-.37-.04c-.72-.1-1.55-.43-1.93-1.33-.73-1.74.32-3.97 2.32-4.13.74-.06 1.15.21 1.38.56z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M271.46 129.29a14 14 0 0 1-1.9 3.6q-.38-.03-.95-.26c-1.56-.63-1.87-3.33-.03-4.47 1.4-.87 2.57.07 2.88 1.13Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M278.13 128.99a10 10 0 0 1-1.88 2.94c-.97-.4-1.7-1.72-.85-2.78.81-1.02 2.12-.92 2.73-.15z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M278.64 136.47c-.77 2.46-3.47 3.73-6 4.68.19-.23.34-.58.38-1.24.13-1.98-1.45-2.61-2.95-2.33-2.04.37-2.6 3.15-1.46 4.16q.28.25.63.37c-2.65.41-5.39-.02-5.77-2.72l-.03-.22c-.29-2.9 2.05-4.35 7.45-5.24q1.63-.27 3.02-.32c3.34-.13 5.4.72 4.73 2.86Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M273.02 139.9c-.04.67-.19 1.01-.38 1.24q-.41.16-.83.3c-.78.28-1.67.52-2.57.66a2 2 0 0 1-.63-.37c-1.14-1.02-.58-3.79 1.46-4.16 1.5-.28 3.08.35 2.95 2.33Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M257.88 129.05c0 2.35-.18 4.57-.65 6.37h-.02c-.56.19-1.23.19-1.95-.25-1.93-1.2-2.07-4.29-.64-5.75 1-1.02 2.28-1.06 3.27-.38z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m269.24 142.11-3.09 3.88h-14.19a10 10 0 0 0 2.37-4.3c.26-.88.42-1.73.52-2.46 1.15-.64 1.91-2.01 2.38-3.79 1.12.61 4.04 1.41 5.83-1.07q.44-.6.86-1.59c.58 1.32 2.1 2.28 4 1.46a4.5 4.5 0 0 0 1.65-1.36h.08c.2.47.58.87 1.25 1.04-5.4.89-7.74 2.34-7.45 5.24l.03.22c.38 2.7 3.13 3.13 5.77 2.72z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="m341.92 103.03-11.98 40.46h-51.47l11.55-39a10.1 10.1 0 0 1 9.69-7.23h37.91c3 0 5.16 2.89 4.31 5.77z" fill={shades.white} />
      <path d="m320.44 118.66-1.56 6.25h-3.13l.78-3.12h-3.12l-.78 3.12h-3.13l1.56-6.25z" fill={shades.black} />
      <path d="M329.93 143.49v.23a4.2 4.2 0 0 1-4.18 4.18h-78.3v-.69a3.7 3.7 0 0 1 3.72-3.72z" fill={shades.white} />
      <path
        className={strokeStyle}
        d="M167.8 187.92c38.31 0 69.37-4.27 69.37-9.53s-31.06-9.53-69.37-9.53-69.37 4.27-69.37 9.53 31.06 9.53 69.37 9.53Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M156.79 25.47s-4.62-1.51-4.87 1.78c-.19 2.59.95 7.8 1.44 9.91a1.2 1.2 0 0 0 2.35-.23l.23-5.95c.02-.4.23-.76.56-.97l1.54-.96c.54-.33.72-1.02.42-1.58-.43-.82-1.09-1.86-1.69-2z"
        fill={shades.white}
      />
      <path
        d="M189.72 29.24s4.83-.51 4.39 2.76c-.35 2.57-2.56 7.43-3.48 9.39-.24.5-.79.77-1.33.65a1.2 1.2 0 0 1-.93-1.37l1.02-5.86a1.2 1.2 0 0 0-.35-1.07l-1.31-1.26a1.2 1.2 0 0 1-.08-1.63c.59-.71 1.45-1.59 2.07-1.6z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M173.69 26.6c-4.91 2.66-10.75 4-17.72 3.75a18 18 0 0 1-.29-3.21v-.21a17.5 17.5 0 0 1 1.89-7.7s3.21-2.93 9.88-3.69a31 31 0 0 0 4.76 9.3q.7.92 1.49 1.76z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M190.76 27.14q0 1.98-.42 3.85-.38 1.66-1.04 3.18c-6.7-.88-11.82-3.5-15.61-7.57a25 25 0 0 1-1.49-1.76 31 31 0 0 1-4.76-9.3 30 30 0 0 1 6.35-.02 27 27 0 0 1 12.66 4.44 23 23 0 0 1 3.89 3.35q.41 1.85.42 3.83Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M189.29 34.16a18 18 0 0 1-2.27 3.8q-.84-.2-1.66-.44a32 32 0 0 1-11.67-6.54 40 40 0 0 1-16.98 2.08q-.47-1.32-.74-2.72c6.97.25 12.81-1.09 17.72-3.74 3.78 4.06 8.9 6.68 15.61 7.56z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M187.02 37.96a17.53 17.53 0 0 1-30.26-4.76l-.05-.14c5.61.43 11.26-.01 16.98-2.08a32 32 0 0 0 13.33 6.98Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M190.34 23.31a23 23 0 0 0-3.89-3.35 26.6 26.6 0 0 0-12.66-4.44 30 30 0 0 0-6.35.02c-6.67.76-9.88 3.69-9.88 3.69a17.55 17.55 0 0 1 32.78 4.08Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M186.82 16.07a17.55 17.55 0 0 0-29.98 4.75c-.01-.19-1-15.77 5.13-18.52 6.17-2.77 20.2-2.45 23.33 1.9a9.5 9.5 0 0 1 1.36 3.99c.37 2.44.32 5.35.15 7.89z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M190.33 30.98a17 17 0 0 0 0-7.67c-.6-2.7-1.83-5.17-3.51-7.24.17-2.54.22-5.45-.15-7.89 5.35 4.88 7.82 11.66 3.66 22.81z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M181.41 56.54c-.31 1.97-4.28 3.52-9.14 3.52h-.18c-4.98-.04-8.98-1.71-8.98-3.77q0-.5.3-.96a25 25 0 0 1 9.52-.98q4.44.42 8.48 2.19Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M204.44 175.72H128.6c-16.14 0-27.69-14.89-22.9-29.57 9.13-27.97 24.55-66.34 44.52-83.28a42 42 0 0 1 8.72-5.8 30 30 0 0 1 4.47-1.74q-.3.47-.3.96c0 2.06 4.01 3.73 8.98 3.77h.18c4.86 0 8.83-1.56 9.14-3.52 4.17 1.8 8.04 4.6 11.63 8.16a70 70 0 0 1 9.33 11.81c6.4 9.99 11.62 22.37 15.83 35.06a342 342 0 0 1 9.76 36.9c2.95 14.1-8.41 27.24-23.52 27.24z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        d="m202.36 76.51-.12.33-.2.51-.28.71q-1 2.5-2.24 5.25c-6.02 13.35-16.09 30.6-24.93 44.46l-6.9.48c.35-.53 1.69-3.41 3.58-7.71 3.82-8.69 9.9-23.19 14.78-35.83 3.01-7.79 5.55-14.87 6.83-19.47l.15-.55a69 69 0 0 1 9.32 11.81z"
        fill={shades.primary.medium}
      />
      <path
        d="m167.7 128.25-5.99.6c-2.7-7.28-5.11-16.3-7.02-25.74v-.01c-2.75-13.59-4.44-28.06-4.46-39.45v-.77a42 42 0 0 1 8.72-5.8l-.04.4c-1.08 12.18 1.19 33.5 5.76 56.64l.01.05c.2 1.03.77 3.65 1.36 6.38h-.05q.82 3.84 1.71 7.71z"
        fill={shades.primary.medium}
      />
      <path
        className={strokeStyle}
        d="M204.44 175.72H128.6c-16.14 0-27.69-14.89-22.9-29.57 9.13-27.97 24.55-66.34 44.52-83.28a42 42 0 0 1 8.72-5.8 30 30 0 0 1 4.47-1.74q-.3.47-.3.96c0 2.06 4.01 3.73 8.98 3.77h.18c4.86 0 8.83-1.56 9.14-3.52 4.17 1.8 8.04 4.6 11.63 8.16a70 70 0 0 1 9.33 11.81c6.4 9.99 11.62 22.37 15.83 35.06a342 342 0 0 1 9.76 36.9c2.95 14.1-8.41 27.24-23.52 27.24z"
        strokeWidth={strokeWidth}
      />
      <path d="M154.52 38.08c1.38 6.82 9.61 47.58 16.32 49.65" stroke="white" />
      <path d="M189.3 42.04s-3.94 13.9-7.41 20.11c-4.16 7.43-8.12 14.02-11.05 25.58-3.04 12.01-3.14 40.52-3.14 40.52" stroke="white" />
      <path
        className={strokeStyle}
        d="M127.93 111.94c-5.1-.4-25.93 14.75-26.99 34.11s18.17 39.51 36.67 30.72 16.6-62.75-9.68-64.83Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M140.88 165.57c8.36-4.83 10.57-16.64 4.94-26.39s-16.96-13.74-25.32-8.91-10.57 16.63-4.94 26.38 16.97 13.74 25.32 8.92Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M222.73 124.2c15.11 8.34 18.9 41.85.39 50.65s-35.45-24.97-35.45-36.13 19.94-22.85 35.05-14.52z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M207.92 175.37c8.36-4.83 10.57-16.64 4.94-26.39s-16.96-13.74-25.32-8.91-10.56 16.63-4.94 26.38 16.97 13.74 25.32 8.92Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M160.22 125.36c-3.59 1.4-8.15 2.13-10 .57l.42-5.6a4.44 4.44 0 0 0-4.31-3.35h-2.01a8.2 8.2 0 0 0 4.28-5.37 13 13 0 0 1 5.43-1.23c-.52 1.26-.74 3.15.96 5.14 2.32 2.72 6.13 1.98 6.72-.63 1.87 3.21 1.48 7.39-1.49 10.47Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M148.6 111.6q-.05.25-.13.51a8.2 8.2 0 0 1-4.15 4.86h-2.45c-.74 0-1.38.49-1.59 1.2l-.62 2.16.35 9.71-1.81-4.62c-.66.08.51 4.85-.1 5.07-.58-1.11-3.24-6.76-4.42-7.62-2.34-1.72-12.59-6.48-20.24-4.89-.5-2.2-1.13-7.42 2.75-11.86 5.06-5.79 12.38-9.63 20.75-7.5q1.75.45 3.27 1.13a10.3 10.3 0 0 0-2.49 4.51c-.82 2.99-.15 6.51 4.78 6.2 3.59-.23 5.11-1.76 5.04-4.41a8 8 0 0 1 1.05 5.56z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M194.58 129.58a15 15 0 0 0-4.11-.54c-2.21 0-4.24.33-6.07.9-2.44.11-4.68-.98-5.38-4.3.76-2.26 2.63-6.38 6.34-7.1 2.36-.46 4.72 1.01 5.71 5.05a12.7 12.7 0 0 0 3.51 5.99Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M185.36 139.15v29.67h-16.65a17.98 17.98 0 0 0-1.01-29.67z" fill={shades.white} />
      <path
        d="M185.36 168.82v6.28a8.5 8.5 0 0 1-8.5 8.22h-37.65a8.5 8.5 0 0 1-8.51-8.51v-5.98h16.65a18 18 0 0 0 10.68 3.51c4 0 7.69-1.3 10.68-3.51h16.65z"
        fill={shades.white}
      />
      <path className={strokeStyle} d="M150.65 120.32h-10.98l.96-3.35h9.17z" fill={shades.white} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M151.92 125.36H139.2q-.5 0-.99.06l1.46-5.09h10.97z" fill={shades.white} strokeWidth={strokeWidth} />
      <path d="M175.87 136.33a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3Z" fill={shades.white} />
      <path
        d="M185.36 133.87v5.28H167.7a17.9 17.9 0 0 0-19.34 0H130.7v-5.28a8.5 8.5 0 0 1 8.51-8.5h37.65c4.7 0 8.51 3.81 8.51 8.51z"
        fill={shades.white}
      />
      <path d="M147.34 168.82h-16.65v-29.67h17.66a17.98 17.98 0 0 0-1.01 29.67Z" fill={shades.white} />
      <path
        d="m149.13 131.65-.2 2.39a1.5 1.5 0 0 1-1.49 1.38h-10.06c-.88 0-1.57-.75-1.49-1.62l.2-2.39a1.5 1.5 0 0 1 1.49-1.38h10.06c.88 0 1.57.75 1.49 1.62Z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M167.7 139.15a18 18 0 0 0-9.67-2.82 17.98 17.98 0 0 0-10.68 32.49 18 18 0 0 0 10.68 3.51 17.98 17.98 0 0 0 9.67-33.18Zm-9.67 28.12a12.94 12.94 0 1 1 0-25.88 12.94 12.94 0 0 1 0 25.88Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M158.03 141.39a12.94 12.94 0 1 0 0 25.88 12.94 12.94 0 0 0 0-25.88Zm0 16.64a3.7 3.7 0 1 1 0-7.4 3.7 3.7 0 0 1 0 7.4Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M161.73 154.33a3.7 3.7 0 1 1-7.4 0 3.7 3.7 0 0 1 7.4 0Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M206.22 183.31h-4.48a20 20 0 0 1-6.36-4.2c-2.53 1.79-6.9 4.2-12.2 4.2a4.6 4.6 0 0 1-2.73-.8c-2.45-1.74-2.61-6.08.34-10.51-.11 1.85.22 4.11 2.39 4.53q1.13.2 2.05-.25c2.75-1.31 3.69-6.34.13-7.86q-.5-.21-1.1-.33l.07-.06.85-.72c-1.25.45-2.62.76-3.98.72-3.86-.11-8.06-3.55-5.17-10.01a21 21 0 0 1 1.63-2.99c-.48 2.51-.38 5.23 2.2 5.52a5.6 5.6 0 0 0 5.51-2.56c1.01-1.55 1.29-3.49.65-4.93q-.3-.7-.65-1.28a6 6 0 0 0-2.16-2.29q1.06-.69 2.16-1.23l.24-.12c5.65-2.67 11.94-2.47 15.57-1.13q3.52 1.3 6.45 4.08c4.38 4.15 7.59 10.67 8.95 19.08 1.98 12.23-10.35 13.15-10.35 13.15z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M185.36 167.15c7.41-6.17 14.07-8.55 19.3-4.82" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M195.39 179.11c1.5-1.06 2.35-1.91 2.35-1.91" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M130.69 153.05a10 10 0 0 1-6.04 1.28c-8.72-.52-13.52-7.97-15.09-15.68-.74-3.67.43-5.59 1.87-6.6 2.67 3.58 6.57 5.62 8.87 6.6l.16.07c-1.1 1.99-2.06 4.86-.29 7.08 3.02 3.8 6.74 1.88 7.84-.96a5.3 5.3 0 0 0-.36-4.5q1.7.06 3.03-.23a6 6 0 0 0 1.7-.62c1.35 1.45 2.28 3.08 2.43 4.63.24 2.44-.58 6.77-4.13 8.93z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M207.62 151.08a19 19 0 0 0-6.45-4.08c-3.63-1.34-9.92-1.54-15.57 1.13l-.24.12a19 19 0 0 0-5.64 4.16q-.7.1-1.38.07a7.2 7.2 0 0 1-6.99-6.94c-.08-1.22.22-2.79.9-4.48.42 1.56 1.23 3.35 2.82 4.32 3.22 1.97 6.29-.49 5.71-4.73-.45-3.23-2.85-4.48-5.51-4.57a19.3 19.3 0 0 1 15.21-7.05q2.24 0 4.11.54c10.1 2.81 12.48 15.91 13.04 21.5z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M136.3 125.86a9 9 0 0 0-2.61-3c-2.34-1.72-12.59-6.48-20.24-4.89l-.73.17c-2.7.72-4.42 4.73-3.93 7.72.4 2.44 1.39 4.49 2.65 6.19 2.67 3.58 6.57 5.62 8.87 6.6l.16.07c2.46 1.02 5 1.55 7.19 1.63q1.7.06 3.03-.23a6 6 0 0 0 1.7-.62c3.71-2.18 6.44-8.75 3.91-13.62zm-5.61 8.23q-.63.67-1.24.86c-2.48.72-6.93-2.07-6.61-5.82s4.13-5.53 7.8-4.42c1.65.5 2.31 1.79 2.36 3.3a9.4 9.4 0 0 1-2.32 6.07z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M128.03 144.84c-1.1 2.84-4.82 4.76-7.84.96-1.77-2.23-.81-5.09.29-7.08 2.46 1.02 5 1.55 7.19 1.63.71 1.33.98 2.89.36 4.5z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M130.69 134.09q-.63.67-1.24.86c-2.48.72-6.93-2.07-6.61-5.82s4.13-5.53 7.8-4.42c1.65.5 2.31 1.79 2.36 3.3a9.4 9.4 0 0 1-2.32 6.07z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M142.51 110.46c-4.93.31-5.6-3.21-4.78-6.2.56-2.05 1.51-3.5 2.49-4.51 3.43 1.52 5.96 3.84 7.33 6.3.07 2.65-1.45 4.19-5.04 4.41Z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M150.65 120.32h-10.97l.62-2.16c.2-.71.85-1.2 1.59-1.2h6.63c.75 0 1.41.51 1.6 1.24l.53 2.11z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M151.92 125.36h-13.17l-.29.02-.13.01h-.11l1.46-5.09h10.97l1.27 5.03z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M138.29 125.4h-.08z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M161.71 114.89c-.6 2.61-4.4 3.35-6.72.63a4.8 4.8 0 0 1-.96-5.14 9.3 9.3 0 0 1 7.67 4.52z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M201.74 183.31h-18.55c5.3 0 9.67-2.4 12.2-4.2a20 20 0 0 0 6.36 4.2z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M185.23 176.28q-.9.46-2.05.25c-2.17-.42-2.5-2.69-2.39-4.53a20 20 0 0 1 3.46-3.9q.61.1 1.1.33c3.56 1.52 2.62 6.55-.13 7.86z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m185.36 167.15-.19.16" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M185.36 157.99a5.6 5.6 0 0 1-5.51 2.56c-2.58-.29-2.68-3-2.2-5.52q.95-1.45 2.06-2.62a19 19 0 0 1 3.48-2.93 6 6 0 0 1 2.16 2.29q.35.6.65 1.28c.63 1.44.36 3.38-.65 4.93z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M175.07 145.39c-1.59-.97-2.4-2.76-2.82-4.32a19 19 0 0 1 3.01-4.98c2.66.09 5.07 1.34 5.51 4.57.59 4.25-2.48 6.71-5.71 4.73z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m185.36 167.15-.19.16" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M140.29 118.17c-4.02.47-9.63-.63-17.14-4.71" strokeWidth={strokeWidth} />
    </svg>
  );
};
